import React, { useEffect, useState } from 'react';
import { Check, Copy } from 'lucide-react';

import styles from './support.module.scss';

export const SUPPORT_EMAIL = 'help@mycanvas.com';
const COPIED_RESET_MS = 2000;

const CopyEmailButton = () => {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!copied) return undefined;
    const timer = setTimeout(() => setCopied(false), COPIED_RESET_MS);
    return () => clearTimeout(timer);
  }, [copied]);

  const copyEmail = async () => {
    try {
      await navigator.clipboard.writeText(SUPPORT_EMAIL);
      setCopied(true);
    } catch {
      // Clipboard can be blocked (permissions, insecure context). The address stays visible to copy by hand.
    }
  };

  const StateIcon = copied ? Check : Copy;

  return (
    <button type="button" className={styles.copyButton} onClick={copyEmail}>
      <StateIcon size={16} aria-hidden="true" />
      <span aria-live="polite">{copied ? 'Copied' : 'Copy'}</span>
      {!copied && <span className={styles.visuallyHidden}> email address</span>}
    </button>
  );
};

export default CopyEmailButton;
